import { BaseCompositeControl } from '@Common/Controls/BaseCompositeControl';
import { DropDown } from '@Common/Controls/DropDown';
import { FileInput } from '@Common/Controls/FileInput';
import { IGridLayoutParameters } from '@Common/Controls/GridLayout';
import { withSuppression } from '@Common/Core/Decorators';
import { ImageStretch } from '@Common/Enums/Enum';
import * as commonUtils from '@Common/Helpers/CommonUtils';
import StylesHelper from '@Common/Helpers/StylesHelper';
import { ImageBackground } from '@InstanceFactory';

export class SelectImage extends BaseCompositeControl {
    private readonly stretch = new DropDown({ sortable: false });
    private readonly fileInput = new FileInput({ name: strings.backgroundEditor.selectImage, width: '100%' });
    private readonly preview = $('<div>').addClass('select-image-preview');
    private value = ImageBackground.create();

    constructor() {
        super();
        this.stretch.items(ImageStretch.getValues());
        this.stretch.selectItemsById(ImageStretch.none);
        this.stretch.onChange(this.stretchChanged);
        this.fileInput.onChanged(this.fileChanged);
        this.createRoot();
    }

    private readonly stretchChanged = () => {
        this.value.stretch = this.stretch.getFirstOrDefaultId();
        this.updateView();
    };

    private readonly fileChanged = data => {
        this.value.data = { $type: 'System.Byte[], mscorlib', $value: data };
        this.updateView();
    };

    protected initLayout(): IGridLayoutParameters {
        return {
            rows: [{ style: { height: '*' } }],
            columns: [{ style: { width: '*' } }, { style: { width: '150px', minWidth: '150px' } }],
            cells: [
                { rowIndex: 0, columnIndex: 0, content: this.preview },
                {
                    rowIndex: 0,
                    columnIndex: 1,
                    table: {
                        columns: [{ style: { width: '100%' } }],
                        rows: [{ style: { height: 'auto' } }, { style: { height: 'auto' } }, { style: { height: '*' } }],
                        cells: [
                            { rowIndex: 0, columnIndex: 0, content: this.stretch },
                            { rowIndex: 1, columnIndex: 0, content: this.fileInput }
                        ]
                    }
                }
            ]
        };
    }

    @withSuppression('stretchChanged', 'fileChanged')
    private updateView(): void {
        const { stretch, data } = this.value;
        this.stretch.selectItemsById(stretch);
        this.preview.css('background-size', StylesHelper.getImageBackgroundSize(stretch));
        if (this.value.data) {
            this.preview.css('background-image', `url(${commonUtils.getImageSrc({ $value: data.$value })})`);
        } else {
            this.preview.css('background', 'none');
        }
    }

    public setValue(value: ImageBackground): void {
        this.value = value || ImageBackground.create();
        this.updateView();
    }

    public getValue(): ImageBackground {
        return this.value;
    }
}
